import { Injectable } from '@angular/core';
import { AbstractAnnotationStore2D } from '../../annotation-shared/state/root/abstract-annotation-store-2d';
import { VideoState } from './video-state';

@Injectable()
export class VideoStore extends AbstractAnnotationStore2D<VideoState> {
  constructor() {
    super(new VideoState());
  }
}
